<template>
  <div id="app">
    <vue-page-stack>
      <router-view :key="$route.fullPath"></router-view>
    </vue-page-stack>

    <Navbar v-if="$route.meta.navShow" />

    <!-- <div class="FloatingButton" v-if="$route.meta.qrcodeShow && $route.meta.qrcodeShow == true && followShow" @click="showQRcode = true">
      <div class="FloatingButton_icon">
        <van-icon class="close" name="close" @click.stop="closeFollowButton" />
        <img src="@/assets/images/FloatingButton.png" />
      </div>
      <span>关注服务号</span>
    </div>
    <van-overlay :show="showQRcode">
      <div class="QRcode">
        <div class="QRcodeBox">
          <van-icon class="close" name="close" @click="showQRcode = false" />
          <img src="@/assets/images/qrcode.jpg" />
          <p>请长按图片识别二维码</p>
        </div>
      </div>
    </van-overlay> -->
    <Draggable :offset="{ x: 15, y: 185 }" v-if="FloatingButton && showFloatingButton && this.$route.meta.qrcodeShow == true">
      <div class="FloatingButton" @click.stop="FloatingButtonClick">
        <div class="FloatingButton_icon">
          <van-icon class="close" name="close" @click.stop="closeFollowButton" />
          <img :src="FloatingButton.File_Url" />
        </div>
        <span>{{ FloatingButton.Title }}</span>
      </div>
    </Draggable>

    <van-overlay :show="showFloatingPopup">
      <div class="QRcode">
        <div class="QRcodeBox">
          <van-icon class="close" name="close" @click="showFloatingPopup = false" />
          <div class="QRcodeContent" v-if="FloatingButton" v-html="FloatingButton.Content"></div>
        </div>
      </div>
    </van-overlay>

    <!-- 开屏弹窗 -->
    <van-popup class="AdvertisingPopup" v-model="AdvertisingPopup" overlay-class="AdvertisingOverlay" :close-on-click-overlay="false">
      <van-icon class="close" name="clear" @click="closeAdvertisingPopup" />
      <div class="AdvertisingList">
        <van-swipe class="my-swipe" indicator-color="#CA001B">
          <van-swipe-item v-for="(item, index) in AdvertisingList" :key="index" @click="imgclick(item)">
            <img class="AdvertisingImg" :src="item.File_Url" />
          </van-swipe-item>
        </van-swipe>
      </div>
    </van-popup>

    <Questionnaire v-if="showQuestionnaire" :showType="2" :questionId="questionId" :correlationId="correlationId" :pageType="pageType" @changeQuestionStatus="changeQuestionStatus" />
    <img class="questionIcon" v-if="showQuestionIcon" src="./assets/images/question_icon.png" @click="clickQuestionIcon" />
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import mixin from './common/mixin/mixins'
import { mapState } from 'vuex'
import Navbar from './components/navbar.vue';
import Draggable from './components/draggable.vue';
import Questionnaire from './components/questionnaire.vue';
export default {
  data() {
    return {
      showFloatingPopup: false,
      showFloatingButton: false,
      FloatingButton: null,
      AdvertisingPopup: false,
      AdvertisingList: [],
      showQuestionnaire: false,
      showQuestionIcon: false
    }
  },
  mixins: [mixin],
  computed: {
    ...mapState(['userInfo', 'followShow'])
  },
  watch: {
    userInfo: {
      handler(newVal, oldVal) {
        setTimeout(() => {
          this.getFloatingButton();
          this.getAdvertising();
          this.getQuestion();
        }, 500)
      },
      deep: true,
    }
  },
  components: {
    Navbar,
    Draggable,
    Questionnaire
  },
  created() {
    if (localStorage.getItem("Token")) {
      localStorage.removeItem("Token");
    }
  },
  methods: {
    // closeFollowButton() {
    //   this.$axios.post('/Api/Api/Web/Customer/AddUserIsFollow', {
    //     userid: this.userInfo.Id,
    //     type: 1
    //   }).then(res => {
    //     this.$store.commit('updateFollowShow', false);
    //   })
    // },
    closeFollowButton() {
      this.$axios.post('/Api/Api/Web/Customer/AddUserIsFollow', {
        type: 3,
        sfId: this.FloatingButton.Id
      }).then(res => {
        this.showFloatingButton = false;
      })
    },
    // 获取悬浮框信息
    getFloatingButton() {
      this.$axios.get('/Api/api/Web/ImgFile/GetSF?WebCode=' + sessionStorage.getItem('random')).then(res => {
        if(res.Data && Object.keys(res.Data).length !== 0) {
          this.FloatingButton = res.Data;
          this.showFloatingButton = true;
        }
      })
    },
    FloatingButtonClick() {
      if(this.FloatingButton.Type == 1) {
        if(this.FloatingButton.LinkUrl) {
          if(this.FloatingButton.LinkType == 1) {
            location.href = this.FloatingButton.LinkUrl;
          } else if(this.FloatingButton.LinkType == 2 ) {
            wx.miniProgram.navigateTo({url: this.FloatingButton.LinkUrl})
          } else if(this.FloatingButton.LinkType == 3) {
            if (this.FloatingButton.LinkUrl.indexOf('?') !== -1) {
              this.FloatingButton.LinkUrl += '&sourceType=5&sourceId=' + this.FloatingButton.Id;
            } else {
              this.FloatingButton.LinkUrl += '?sourceType=5&sourceId=' + this.FloatingButton.Id;
            }
            this.$router.push(this.FloatingButton.LinkUrl);
          }
          this.BuriedPoint(4, '', '', this.FloatingButton.LinkUrl, this.FloatingButton.Id);
        }
      } else if(this.FloatingButton.Type == 2) {
        this.showFloatingPopup = true;
        this.BuriedPoint(4, '', '', '', this.FloatingButton.Id);
      }
    },
    // 获取开屏信息
    getAdvertising() {
      this.$axios.post('/Api/api/Web/ImgFile/GetCFList?WebCode=' + sessionStorage.getItem('random')).then(res => {
        if(res.Data && res.Data.length > 0 && this.$route.meta.qrcodeShow == true) {
          this.AdvertisingPopup = true;
          this.AdvertisingList = res.Data;
        }
      })
    },
    closeAdvertisingPopup() {
      this.AdvertisingPopup = false;
      this.$axios.post('/Api/Api/Web/Customer/AddUserIsFollow', {
        type: 2
      }).then(res => {
      })
    },
    imgclick(info) {
      if(info.LinkType && info.LinkUrl) {
        this.AdvertisingPopup = false;
        this.$axios.post('/Api/Api/Web/Customer/AddUserIsFollow', {
          type: 2
        }).then(res => {
          if(info.LinkType == 1) {
            let objExp=new RegExp(/^(f|ht)tps?:\/\//i);
            if(objExp.test(info.LinkUrl)) {
              location.href = info.LinkUrl;
            } else {
              this.$router.push(info.LinkUrl);
            }
          } else if(info.LinkType == 2) {
            wx.miniProgram.navigateTo({url: info.LinkUrl})
          } else if(info.LinkType == 3) {
            if (info.LinkUrl.indexOf('?') !== -1) {
              info.LinkUrl += '&sourceType=4&sourceId=' + info.Id;
            } else {
              info.LinkUrl += '?sourceType=4&sourceId=' + info.Id;
            }
            this.$router.push(info.LinkUrl);
          }
        })
      }
      this.BuriedPoint(5, '', '', info.LinkUrl, info.Id);
    },
    getQuestion() {
      this.showQuestionnaire = false;
      this.showQuestionIcon = false;
      this.$axios.post("/Api/Api/Web/Question/Q").then(res => {
        let data = res.Data;
        const foundUrl = data.find(item => item.url == this.$route.path && (item.Id == this.$route.query.id || (item.Id == 0 && !this.$route.query.id)));
        if(foundUrl) {
          this.questionId = foundUrl.QId;
          this.correlationId = foundUrl.Id;
          this.pageType = foundUrl.Type;
          if(foundUrl.IsPopUp && !foundUrl.IsClose) {
            this.showQuestionnaire = true;
          }
          if(foundUrl.IsPopUp && foundUrl.IsClose) {
            this.showQuestionIcon = true;
          }
        }
      });
    },
    clickQuestionIcon() {
      this.showQuestionnaire = true;
    },
    changeQuestionStatus(status) {
      this.showQuestionnaire = status.showQuestionnaire;
      this.showQuestionIcon = status.showQuestionIcon;
    }
  }
}
</script>

<style lang="scss" scoped>
.FloatingButton {
  // position: fixed;
  // right: 10px;
  // bottom: 135px;
  text-align: center;
  .FloatingButton_icon {
    position: relative;
    display: inline-block;
  }
  .close {
    position: absolute;
    top: -6px;
    right: -12px;
  }
  img {
    width: 35px;
  }
  span {
    display: block;
    font-size: 11px;
    color: #CA001B;
    white-space: nowrap;
  }
}

.QRcode {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .QRcodeBox {
    position: relative;
    width: 80%;
    background-color: #FFFFFF;
    border-radius: 10px;
    padding: 30px 10px 15px;
    box-sizing: border-box;
    .close {
      position: absolute;
      top: 6px;
      right: 8px;
      font-size: 18px;
    }
    img {
      display: block;
      width: 86%;
      margin: 0 auto;
    }
    p {
      font-size: 12px;
      text-align: center;
      margin-top: 5px;
    }
  }
}

/deep/ .QRcodeContent > p > img {
  width: 100%;
}
/deep/ .QRcodeContent img {
  width: 100%;
}

.AdvertisingPopup {
  width: 90%;
  border-radius: 14px;
  box-sizing: border-box;
  text-align: center;
  overflow-y: visible;
  .close {
    position: absolute;
    top: -30px;
    right: 0px;
    font-size: 24px;
    z-index: 99;
    opacity: 0.7;
  }
  .AdvertisingList {
    border-radius: 14px;
    overflow: hidden;
    .AdvertisingImg {
      display: block;
      width: 100%;
    }
  }
}
/deep/ .AdvertisingOverlay {
  background-color: rgba(0, 0, 0, .4) !important;
}

.questionIcon {
  position: fixed;
  right: 10px;
  bottom: 205px;
  width: 48px;
  z-index: 99;
}
</style>
